import { render, staticRenderFns } from "./BusinessDashboard.vue?vue&type=template&id=e70f54ba&scoped=true"
import script from "./BusinessDashboard.vue?vue&type=script&lang=js"
export * from "./BusinessDashboard.vue?vue&type=script&lang=js"
import style0 from "./BusinessDashboard.vue?vue&type=style&index=0&id=e70f54ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f54ba",
  null
  
)

export default component.exports